export default __webpack_public_path__ + "static/media/plus.b63fad46.svg";